export default __webpack_public_path__ + "static/lux-bands-8a2cb2327d485f4eaf8d9a18b9c9696c.jpg";